module.exports = __webpack_public_path__ + "fonts/iconfont.0b778f5.woff";